<template>
	<div class="popup-content" v-show="show">
		<div class="line-one"></div>
		<div class="line-two"></div>
		<scroller :snapping="snapping" :size="size" :positionY="positionY" :autoResize="false" @on-scrollend="scrollEnd" v-show="show">
			<ul class="popup-ul" :id="containerId">
				<li v-for="(item, index) in dataList" class="popup-li" :key="index">{{item}}</li>
			</ul>
		</scroller>
		<div class="sel-top"></div>
		<div class="sel-bottom"></div>
	</div>
</template>
<script>
import { Scroller } from '@58fe/v5';
export default {
	props: {
		snapping: {
			type: Boolean,
			default: true
		},
		dataList: {
			type: Array,
			default: []
		},
		selectedIndex: {
			type: Number,
			default: 2
		},
		show: {
			type: Boolean,
			default: false
		},
		scrollIndex: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			containerId:
				'ul-' +
				Math.random()
					.toString(36)
					.substring(3, 10),
			container: undefined,
			size: this.dataList.length,
			positionY: 0,
			snapHeight: 1,
			firstShow: true // 只有初始化展示进行定位，后面滚动之后的定位不再进行定位计算
		};
	},
	watch: {
		show(val) {
			if (val) {
				// 初始化滚动行高及初始化位置
				if (this.snapping && this.snapHeight === 1) {
					this.$nextTick(function() {
						this.snapHeight =
							this.container.offsetHeight / this.dataList.length;
						this.positionY = this.snapHeight * this.selectedIndex;
					});
				}
			}
		}
	},
	mounted() {
		this.container = document.getElementById(this.containerId);
	},
	components: {
		Scroller
	},
	methods: {
		scrollEnd(position) {
			// 只存下展示时位置
			if (this.show) {
				let top = position.top,
					selectedIndex = Math.round(top / this.snapHeight); // 滚动停止之后滚动距离顶部的个数
				this.$emit('scrollEnd', selectedIndex, this.scrollIndex);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../assets/style/public.scss';
.popup-content {
	height: px2rem(486px);
	margin: 0 px2rem(75px);
	position: relative;
	overflow: hidden;
}
.popup-ul {
	color: #000;
	z-index: 10;
}

.popup-li {
	height: px2rem(97px);
	line-height: px2rem(97px);
	text-align: center;
	font-size: px2rem(40px);
}
.line-one,
.line-two {
	border-top: 1px solid #e3e3e4;
	position: absolute;
	width: 100%;
}
.line-one {
	top: px2rem(194px);
}
.line-two {
	top: px2rem(291px);
}
.sel-top,
.sel-bottom {
	position: absolute;
	left: 0;
	width: 100%;
	height: px2rem(194.4px);
	pointer-events: none;
}
.sel-top {
	top: 0;
	background-image: linear-gradient(
		to bottom,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 0.4) 100%
	);
	background-image: -webkit-linear-gradient(
		to bottom,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 0.4) 100%
	);
	background-image: -moz-linear-gradient(
		to bottom,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 0.4) 100%
	);
}
.sel-bottom {
	bottom: 0;
	background-image: linear-gradient(
		to top,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 0.4) 100%
	);
	background-image: -webkit-linear-gradient(
		to top,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 0.4) 100%
	);
	background-image: -moz-linear-gradient(
		to top,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 0.4) 100%
	);
}
</style>



// WEBPACK FOOTER //
// selectScroll.vue?4227eaec